module.exports = __webpack_public_path__ + "static/media/2.be18fc31.png";